interface Crumb {
  label: string;
  href?: string;
}

export default function SEOBreadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="breadcrumb" className="text-sm text-foreground-500 mb-8">
      {items.map((item, i) => (
        <span key={i}>
          {i > 0 && <span className="mx-2 text-foreground-400">/</span>}
          {item.href ? (
            <a href={item.href} className="hover:text-primary-500 transition-colors">
              {item.label}
            </a>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}